import Tr from 'translations/Translations';

export const ITEM_TYPE = {
	TEXT: 'TEXT',
}

export const ITEM_TYPE_LABEL = {
	[ITEM_TYPE.TEXT]: Tr('text'),
}

const createItem = (key) => ({
	label: ITEM_TYPE_LABEL[key],
	value: key
})

export default [
	createItem(ITEM_TYPE.TEXT)
]